import store from '@/store'
import { Entity } from '@/store/entity'

export class RescueCode extends Entity {
  get experience() {
    if (!this.experience_variation_id) {
      return null;
    }

    const experience = store.getters['experiences/getExperience'](this.experience_variation_id)

    if (!experience) {
      store.dispatch('experiences/fetchExperience', this.experience_variation_id)
    }

    return experience
  }

  get expireAtFormatted() {
    return this.formatDate(this.expire_at, 'DD/MM/YYYY');
  }

  get validatedAtFormatted() {
    return this.formatDate(this.validated_at, 'DD/MM/YYYY');
  }

  get refundFormatted() {
    return this.formatCurrency(this.refund);
  }

  get statusLabel() {
    switch (this.status) {
      case 'active':
        return 'Ativo';
      case 'refund_requested':
      case 'refund_scheduled':
        return 'Reembolso solicitado';
      case 'refunded':
        return 'Reembolsado';
      case 'canceled':
        return 'Cancelado';
      case 'returned':
        return 'Extornado';
      default:
        return this.status;
    }
  }
}
